import React from "react";
import { Search, ChevronDown, Plus, Hand, RefreshCw, User, CheckCircle2, Clock, AlertTriangle, PlayCircle, MapPin, Zap, Phone, Smartphone } from "lucide-react";
import { Pill, Avatar, Mono, Bar, Btn, Panel, MiniStat } from "./primitives";

const JOBS = [
  { id: "JOB-B899B874", title: "Annual boiler service — Plant room", client: "Belmont Estates", addr: "22 Kingsway, London WC2B 6HT", who: "Jay Patel", team: "In-house", when: "14/09 · 09:00–12:00", status: ["green", "Done", CheckCircle2] },
  { id: "JOB-3DF044F7", title: "Emergency lighting 3-hour drain", client: "Capital Holdings", addr: "48 Canal Street, Manchester", who: "Sparks Electrical Ltd", team: "Supplier", when: "17/09 · 18:00–21:30", status: ["blue", "In progress", PlayCircle] },
  { id: "JOB-4E9DC928", title: "Booster pump set — pressure loss", client: "Riverside Residential", addr: "9 Meadow Lane, Leeds LS6 4AB", who: "Nina Cole", team: "In-house", when: "20/09 · 08:30–11:00", status: ["amber", "Overrunning", AlertTriangle] },
  { id: "JOB-8BC1754F", title: "Reception fire alarm panel fault", client: "Capital Holdings", addr: "1 Riverside Walk, Manchester", who: "Jay Patel", team: "In-house", when: "21/09 · 07:30–09:00", status: ["dim", "Scheduled", Clock] },
  { id: "JOB-91AD22C0", title: "Leak investigation — kitchen", client: "Belmont Estates", addr: "14 Mare St, London E8", who: "North Heat Ltd", team: "Supplier", when: "21/09 · 14:30", status: ["blue", "In progress", PlayCircle] },
];

export const JobsTable = ({ compact }) => (
  <div>
    <div className="flex items-center justify-between mb-3">
      <div>
        <div className="font-display text-xl font-bold">Jobs</div>
        <div className="text-[11px] text-mk-muted">13 total</div>
      </div>
      <div className="flex items-center gap-2">
        <div className="hidden sm:flex rounded-md border border-mk-border bg-mk-bg text-[11px] overflow-hidden">
          <span className="px-2.5 py-1 bg-mk-lime text-mk-bg font-semibold">List</span><span className="px-2.5 py-1 text-mk-dim">Month</span><span className="px-2.5 py-1 text-mk-dim">Week</span>
        </div>
        <Btn><Plus className="h-3 w-3" />New Job</Btn>
      </div>
    </div>
    <div className="hidden sm:flex items-center gap-2 mb-3 text-[11px]">
      <div className="flex-1 flex items-center gap-2 rounded-md border border-mk-border bg-mk-bg px-2.5 py-1.5 text-mk-muted"><Search className="h-3 w-3" />Search jobs…</div>
      <div className="flex items-center gap-1 rounded-md border border-mk-border px-2.5 py-1.5 text-mk-dim">All Statuses <ChevronDown className="h-3 w-3" /></div>
      <div className="flex items-center gap-1 rounded-md border border-mk-border px-2.5 py-1.5 text-mk-dim"><Hand className="h-3 w-3" />My Work</div>
      <div className="flex items-center gap-1 rounded-md border border-mk-border px-2.5 py-1.5 text-mk-dim"><RefreshCw className="h-3 w-3" />Recurring</div>
    </div>
    <div className="rounded-lg border border-mk-border overflow-hidden min-w-[420px]">
      <div className="grid grid-cols-[1.5fr_1fr_1.25fr_0.85fr] gap-2 border-b border-mk-border bg-mk-bg/60 px-3 py-2 text-[10px] uppercase tracking-wider text-mk-muted">
        <span>Job</span><span>Client</span><span className="hidden sm:block">Assigned to</span><span className="text-right">Status</span>
      </div>
      {JOBS.slice(0, compact ? 4 : 5).map((j, i) => {
        const [tone, label, Icon] = j.status;
        return (
          <div key={j.id} className={`grid grid-cols-[1.5fr_1fr_1.25fr_0.85fr] gap-2 items-center px-3 py-2.5 text-[11px] border-b border-mk-border/60 last:border-0 ${i === 0 ? "border-l-2 border-l-mk-lime bg-mk-lime/[0.03]" : ""}`}>
            <div className="min-w-0">
              <Mono className="text-[10px]">{j.id}</Mono>
              <div className="truncate font-medium">{j.title}</div>
              <div className="truncate text-[10px] text-mk-muted">{j.when}</div>
            </div>
            <div className="min-w-0"><div className="truncate font-medium">{j.client}</div><div className="truncate text-[10px] text-mk-muted">{j.addr}</div></div>
            <div className="hidden sm:flex items-center gap-1.5 min-w-0"><User className="h-3 w-3 text-mk-muted shrink-0" /><span className="truncate">{j.who}</span><Pill tone={j.team === "Supplier" ? "blue" : "dim"}>{j.team}</Pill></div>
            <div className="text-right"><Pill tone={tone}><Icon className="h-3 w-3" />{label}</Pill></div>
          </div>
        );
      })}
    </div>
  </div>
);

export const AssignPicker = () => (
  <Panel title="Assign JOB-91AD22C0 · Leak investigation" right="One picker, two workforces">
    <div className="grid grid-cols-2 gap-2 text-[11px]">
      <div className="rounded-lg border border-mk-lime/40 bg-mk-lime/5 p-2.5">
        <div className="text-[10px] uppercase tracking-wider text-mk-lime mb-2">In-house operatives</div>
        {[["JP", "Jay Patel", "Free 14:00", true], ["NC", "Nina Cole", "On job until 16:00"], ["OK", "Omar Khan", "Off shift"]].map(([i, n, s, sel]) => (
          <div key={n} className={`flex items-center gap-2 rounded-md px-2 py-1.5 ${sel ? "bg-mk-lime/15" : ""}`}><Avatar initials={i} tone={sel ? "lime" : "dim"} /><div className="flex-1 min-w-0"><div className="font-medium truncate">{n}</div><div className="text-[10px] text-mk-muted">{s}</div></div>{sel && <CheckCircle2 className="h-3.5 w-3.5 text-mk-lime" />}</div>
        ))}
      </div>
      <div className="rounded-lg border border-mk-border p-2.5">
        <div className="text-[10px] uppercase tracking-wider text-[#7fb0ff] mb-2">Suppliers</div>
        {[["NH", "North Heat Ltd", "96 · 3.2 mi · Compliant"], ["CP", "Capital Plumbing", "88 · 5.1 mi · Compliant"], ["GG", "Greenline Gas", "71 · Insurance expiring"]].map(([i, n, s]) => (
          <div key={n} className="flex items-center gap-2 rounded-md px-2 py-1.5"><Avatar initials={i} tone="blue" /><div className="flex-1 min-w-0"><div className="font-medium truncate">{n}</div><div className="text-[10px] text-mk-muted">{s}</div></div></div>
        ))}
      </div>
    </div>
    <div className="mt-3 flex items-center justify-between">
      <span className="text-[10px] text-mk-muted flex items-center gap-1"><Zap className="h-3 w-3 text-mk-lime" />AI suggests North Heat Ltd (96/100)</span>
      <Btn>Assign Jay Patel</Btn>
    </div>
  </Panel>
);

export const CostLines = () => {
  const lines = [["Labour — 2.5h @ £48", 120], ["Thermostatic valve (Danfoss RAS-C2)", 38.5], ["Consumables", 12], ["Call-out (evening)", 45]];
  const sub = lines.reduce((s, l) => s + l[1], 0);
  const mA = sub * 0.15, mB = sub * 0.05, vat = (sub + mA + mB) * 0.2;
  return (
    <Panel title="Cost lines · JOB-91AD22C0" right="Live totals · server-recomputed">
      <div className="text-[11px] space-y-1.5">
        {lines.map(([l, v]) => <div key={l} className="flex justify-between border-b border-mk-border/60 pb-1.5"><span className="text-mk-dim">{l}</span><Mono className="text-mk-text">£{v.toFixed(2)}</Mono></div>)}
        <div className="flex justify-between pt-1"><span className="text-mk-muted">Subtotal</span><Mono className="text-mk-text">£{sub.toFixed(2)}</Mono></div>
        <div className="flex justify-between"><span className="text-mk-muted">Markup A · PM fee 15%</span><Mono className="text-mk-dim">£{mA.toFixed(2)}</Mono></div>
        <div className="flex justify-between"><span className="text-mk-muted">Markup B · Client uplift 5%</span><Mono className="text-mk-dim">£{mB.toFixed(2)}</Mono></div>
        <div className="flex justify-between"><span className="text-mk-muted">VAT 20%</span><Mono className="text-mk-dim">£{vat.toFixed(2)}</Mono></div>
        <div className="flex justify-between items-center pt-2 border-t border-mk-border"><span className="font-semibold">Invoice total</span><span className="font-display text-lg font-bold text-mk-lime">£{(sub + mA + mB + vat).toFixed(2)}</span></div>
      </div>
    </Panel>
  );
};

export const EscalationLadder = () => (
  <Panel title="Escalation ladder · EMG-4E9D · Booster pump pressure loss" right={<span className="text-red-300 font-mono">SLA 00:19:41</span>}>
    <div className="space-y-2">
      {[
        { t: "0–10 min", tier: "Tier 1 — First call", who: "Jay Patel", via: "Push + SMS", state: "ack", time: "Acknowledged 00:04" },
        { t: "10–25 min", tier: "Tier 2 — Escalation", who: "North Heat Ltd (on-call)", via: "Push + SMS", state: "armed", time: "Armed · fires at 10:00" },
        { t: "25+ min", tier: "Tier 3 — Hard escalation", who: "Duty Manager", via: "SMS + phone", state: "queued", time: "Queued" },
      ].map((r, i) => (
        <div key={r.tier} className={`flex items-center gap-3 rounded-lg border p-2.5 text-[11px] ${r.state === "ack" ? "border-mk-lime/40 bg-mk-lime/5" : r.state === "armed" ? "border-red-500/40 bg-red-500/5" : "border-mk-border"}`}>
          <div className="w-16 font-mono text-[10px] text-mk-muted">{r.t}</div>
          <div className={`grid place-items-center h-7 w-7 rounded-full font-mono text-[10px] font-bold ${r.state === "ack" ? "bg-mk-lime text-mk-bg" : r.state === "armed" ? "bg-red-500 text-white animate-pulse" : "bg-mk-raised text-mk-dim"}`}>{i + 1}</div>
          <div className="flex-1 min-w-0"><div className="font-semibold truncate">{r.tier}</div><div className="text-[10px] text-mk-muted truncate">{r.who} · {r.via}</div></div>
          <div className="text-right"><Pill tone="dim" mono>AUTO</Pill><div className="text-[10px] text-mk-muted mt-1">{r.time}</div></div>
        </div>
      ))}
    </div>
    <div className="mt-3 flex items-center gap-2 text-[10px] text-mk-muted"><span className="live-dot" />#emergencies · Slack red-alert posted 00:00 · Teams card posted 00:00</div>
  </Panel>
);

export const QuoteCompare = () => (
  <Panel title="Compare quotes · Roof repair — 42 Cresswell" right="3 suppliers invited">
    <div className="grid grid-cols-3 gap-2 text-[11px]">
      {[
        { n: "North Heat Ltd", p: "£4,180", r: "4.9", a: "Tue", c: "green", win: true },
        { n: "Seal & Sons", p: "£4,650", r: "4.6", a: "Thu", c: "green" },
        { n: "TenPoint", p: "£3,900", r: "4.1", a: "Next wk", c: "red" },
      ].map((q) => (
        <div key={q.n} className={`rounded-lg border p-2.5 ${q.win ? "border-mk-lime/50 bg-mk-lime/5" : "border-mk-border"}`}>
          <div className="font-medium truncate">{q.n}</div>
          <div className="font-display text-lg font-bold mt-1">{q.p}</div>
          <div className="text-[10px] text-mk-muted mt-1">★ {q.r} · avail {q.a}</div>
          <div className="mt-2"><Pill tone={q.c}>{q.c === "green" ? "Compliant" : "Insurance lapsed"}</Pill></div>
          {q.win && <div className="mt-2"><Btn className="w-full justify-center">Pick winner</Btn></div>}
        </div>
      ))}
    </div>
  </Panel>
);

export const ProjectBoard = () => (
  <Panel title="Project · Reception fit-out, Unit 4 Holloway" right="Budget £48k · 61% used">
    <Bar pct={61} className="mb-3" />
    <div className="grid grid-cols-3 gap-2 text-[11px]">
      {[["To do", ["Snagging walk", "Signage install"]], ["In progress", ["Electrical 2nd fix", "Flooring — zone B"]], ["Done", ["Strip-out", "First fix", "Plastering"]]].map(([col, items]) => (
        <div key={col} className="rounded-lg border border-mk-border bg-mk-bg/50 p-2">
          <div className="text-[10px] uppercase tracking-wider text-mk-muted mb-1.5">{col} · {items.length}</div>
          {items.map((t) => <div key={t} className="rounded-md border border-mk-border bg-mk-surface px-2 py-1.5 mb-1.5 truncate">{t}</div>)}
        </div>
      ))}
    </div>
  </Panel>
);

export const ScheduleGrid = () => {
  const ops = [["JP", "Jay Patel"], ["NC", "Nina Cole"], ["OK", "Omar Khan"]];
  const blocks = { JP: [[1, 3, "Boiler service", "lime"], [5, 7, "Leak inv.", "blue"]], NC: [[0, 2, "PPM HVAC", "blue"], [4, 5, "Fire panel", "red"]], OK: [[2, 4, "Contract visit", "dim"], [6, 8, "Booster pump", "amber"]] };
  return (
    <Panel title="Schedule · Tuesday" right="Drag to reassign · conflicts flag instantly">
      <div className="grid grid-cols-[72px_1fr] gap-2 text-[10px]">
        <div />
        <div className="grid grid-cols-8 text-mk-muted font-mono">{["08", "09", "10", "11", "12", "13", "14", "15"].map((h) => <span key={h}>{h}:00</span>)}</div>
        {ops.map(([i, n]) => (
          <React.Fragment key={i}>
            <div className="flex items-center gap-1.5 truncate"><Avatar initials={i} tone="dim" size="h-5 w-5 text-[9px]" /><span className="truncate">{n}</span></div>
            <div className="relative h-8 rounded-md border border-mk-border bg-mk-bg/50 grid grid-cols-8">
              {blocks[i].map(([s, e, l, t]) => (
                <div key={l} className={`absolute top-1 bottom-1 rounded px-1.5 flex items-center truncate ${t === "lime" ? "bg-mk-lime text-mk-bg" : t === "blue" ? "bg-mk-blue text-white" : t === "red" ? "bg-red-500/70 text-white" : t === "amber" ? "bg-amber-500/70 text-mk-bg" : "bg-mk-raised text-mk-text"}`} style={{ left: `${(s / 8) * 100}%`, width: `${((e - s) / 8) * 100}%` }}>{l}</div>
              ))}
            </div>
          </React.Fragment>
        ))}
      </div>
      <div className="mt-2 text-[10px] text-mk-muted flex items-center gap-1"><MapPin className="h-3 w-3 text-mk-lime" />Nudge: two E8 jobs at 14:00 and 16:00 could be one visit.</div>
    </Panel>
  );
};

export const ContractsCalendar = () => (
  <Panel title="Contract C-118 · Fire alarm weekly test · Belmont Estates" right="Weekly · Tue 09:00 · PO BE-2291">
    <div className="grid grid-cols-3 gap-2 mb-3"><MiniStat label="Visits generated" value="12" sub="next 12 weeks" /><MiniStat label="Completed" value="9" tone="text-mk-lime" sub="0 missed" /><MiniStat label="Billing" value="Monthly" sub="1 invoice · £1,080" /></div>
    <div className="grid grid-cols-7 gap-1 text-[10px]">
      {["M", "T", "W", "T", "F", "S", "S"].map((d, i) => <div key={i} className="text-center text-mk-muted">{d}</div>)}
      {Array.from({ length: 28 }).map((_, i) => {
        const isVisit = i % 7 === 1;
        const done = isVisit && i < 21;
        return <div key={i} className={`h-7 rounded-md border text-center leading-7 ${isVisit ? (done ? "border-mk-lime/40 bg-mk-lime/15 text-mk-lime" : "border-mk-blue/40 bg-mk-blue/15 text-[#7fb0ff]") : "border-mk-border/50 text-mk-muted"}`}>{i + 1}</div>;
      })}
    </div>
    <div className="mt-2 flex items-center justify-between text-[10px] text-mk-muted"><span>Client booking: on · 48h notice</span><Pill tone="amber">1 extra visit pending</Pill></div>
  </Panel>
);

export const PropertiesList = () => (
  <Panel title="Belmont Estates · Properties" right="6 sites · 41 assets">
    <div className="space-y-1.5 text-[11px]">
      {[["22 Kingsway, WC2B 6HT", "Office · 12 assets", "Key safe 4471 · Alarm zone B", "green"], ["14 Mare St, E8 4RP", "Residential · 9 assets", "Concierge 07:00–19:00", "green"], ["Unit 4 Holloway, N7", "Industrial · 14 assets", "Contractors: no names shown", "amber"], ["9 Meadow Lane, LS6", "Residential · 6 assets", "WhatsApp access: residents", "green"]].map(([a, t, n, c]) => (
        <div key={a} className="flex items-center gap-3 rounded-lg border border-mk-border px-2.5 py-2"><div className="flex-1 min-w-0"><div className="font-medium truncate">{a}</div><div className="text-[10px] text-mk-muted truncate">{t} · {n}</div></div><Pill tone={c}>{c === "green" ? "Compliant" : "2 due"}</Pill></div>
      ))}
    </div>
  </Panel>
);

export const WebhookFeed = () => (
  <Panel title="Webhooks · #operations" right="Slack Block Kit · Teams MessageCard">
    <div className="space-y-1.5 font-mono text-[10px]">
      {[["06:30", "briefing.daily", "Good morning — 14 jobs today, 1 emergency open", "lime"], ["09:12", "job.completed", "JOB-B899B874 · Boiler service · photos: 4", "green"], ["10:04", "emergency.escalated", "EMG-4E9D → Tier 2 · North Heat Ltd", "red"], ["11:47", "compliance.document_expired", "Greenline Gas · Public liability", "amber"], ["12:30", "invoice.paid", "INV-8BC1 · £1,840.00 via Stripe", "blue"]].map(([t, e, m, c]) => (
        <div key={e + t} className="flex items-start gap-2 rounded-md border border-mk-border bg-mk-bg/50 px-2 py-1.5"><span className="text-mk-muted">{t}</span><Pill tone={c} mono>{e}</Pill><span className="text-mk-dim truncate">{m}</span></div>
      ))}
    </div>
  </Panel>
);

export const _icons = { Phone, Smartphone };
